import { Controller } from "@hotwired/stimulus"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade"

// Overlay chrome for the modal: locks body scroll while open and closes on the
// close control or Escape.
//
// With a close link (ModalComponent#close_href) the modal was served into a
// turbo-frame. Over its host page the frame's page is right underneath, so
// closing is local: drop the modal, clear the frame's src (a restored snapshot
// must not refetch the video) and put the link's address back — no request.
// A close link targeting `_top` (the modal as its own page) stays a real visit.
// Without a close link, closing removes the appended element from the mount.
export default class extends Controller {
  static targets = ["closeLink"]

  connect() {
    disableBodyScroll(this.element)
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    enableBodyScroll(this.element)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  closeViaLink(event) {
    if (this.closesWithVisit) return
    event.preventDefault()
    this.dismiss(this.closeLinkTarget.href)
  }

  close() {
    if (!this.hasCloseLinkTarget) {
      this.element.remove()
    } else if (this.closesWithVisit) {
      this.closeLinkTarget.click()
    } else {
      this.dismiss(this.closeLinkTarget.href)
    }
  }

  dismiss(href) {
    const frame = this.element.closest("turbo-frame")
    this.element.remove()
    if (frame) {
      frame.removeAttribute("src")
      frame.removeAttribute("complete")
    }
    history.replaceState(history.state, "", href)
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  get closesWithVisit() {
    return this.closeLinkTarget.dataset.turboFrame === "_top"
  }
}
